import React from 'react';

import { PromoFlagIcon } from 'apps/promo/components/common/promo-flag-icon/PromoFlagIcon';
import { PromoIcon } from 'apps/promo/components/common/promo-icon/PromoIcon';
import { PromoText } from 'apps/promo/components/common/promo-text/PromoText';

import { AmountCurrencyFlag, AmountCurrencyLabel, AmountCurrencyText } from './styles';

const AmountCurrency = ({ countryCode, currencyCode, toggleCountryList }) => {
    return (
        <AmountCurrencyLabel onClick={toggleCountryList}>
            <AmountCurrencyFlag>
                <PromoFlagIcon name={countryCode.toLowerCase()} size="24px" />
            </AmountCurrencyFlag>
            <AmountCurrencyText>
                <PromoText variant="subheader">{currencyCode}</PromoText>
            </AmountCurrencyText>
            <PromoIcon name="chevron-down" color="gray80" size="24px" />
        </AmountCurrencyLabel>
    );
};

export default AmountCurrency;
